export default "__VITE_ASSET__DJX3db26__"